import { useRef } from 'react';

export default function MagneticButton({ children, className = '', as: Comp = 'button', strength = 0.35, ...rest }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current; if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = 'translate(0,0)'; };

  return (
    <Comp
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`magnetic inline-flex items-center justify-center transition-transform duration-300 ease-out will-change-transform ${className}`}
      {...rest}
    >
      {children}
    </Comp>
  );
}
